let template = `
    <html>
        <head>
            <link rel="stylesheet" href="DOMAIN/css/bootstrap.min.css"/>
            <link rel="stylesheet" href="DOMAIN/serve/pdf.css"/>
            <link id="load-css-0" rel="stylesheet" type="text/css" href="https://www.gstatic.com/charts/46.2/css/core/tooltip.css"/>
            <link id="load-css-1" rel="stylesheet" type="text/css" href="https://www.gstatic.com/charts/46.2/css/util/util.css"/>
            <style>
                html {
                    -webkit-print-color-adjust: exact;
                }
                html, body {
                    width: 210mm;
                    height: 295mm;
                }
                .full-container-width {
                    width: 100%;
                }
                .review-prescription-container {
                    width: auto;
                    height: auto;
                    overflow: visible;
                }
                .patient-plan-template, .patient-prescription-template {
                    page-break-after: always;
                    page-break-inside: avoid;
                    width: 210mm;
                    height: 277mm;
                }
                .patient-prescription-template {
                    margin-top: 0;
                }
                .patient-prescription-template .doctor-container .details {
                    font-size: 13px;
                }
                .patient-prescription-template .patient-prescription-body {
                    height: 245mm;
                }
                .patient-prescription-template.physio-consultation-template .patient-prescription-body {
                    height: 210mm;
                }
                body.print-pdf .patient-prescription-template .patient-prescription-body {
                    height: 205mm;
                }
                .patient-prescription-template .patient-prescription-body .prescription-card {
                    margin-left: 6mm;
                    margin-right: 10mm;
                }
                .patient-prescription-template .patient-prescription-body .prescription-card .sub-details, .patient-prescription-template .prescription-card .prescription-card-header .reasonForVisit, .patient-prescription-template .prescription-date {
                    font-size: 13px;
                }
                .patient-prescription-template .patient-prescription-body .prescription-card-content-container {
                    height: 90%;
                    font-size: 16px;
                }
                .patient-prescription-template .patient-prescription-body .prescription-card-content-container * {
                    font-size: inherit;
                    line-height: 1.5;
                }
                .patient-prescription-template .patient-prescription-body .prescription-card-content-container .prescription-subdesc {
                    font-size: 13px;
                }
                .patient-prescription-template .patient-prescription-body .prescription-card-content-container .dosage-divider {
                    font-size: 16px !important;
                }
                .goals-metric-bar-field, .dosage-row {
                    -webkit-print-color-adjust: exact;
                }
                .cancel-modal, .pdf-generation-status, .action-icons, .pdf-upload-status {
                    display: none;
                }
                .blue-dot, .pink-dot, .green-dot, .royal-blue-dot, .yellow-dot, .purple-dot, .orange-dot {
                    -webkit-print-color-adjust: exact;
                }
                .patient-prescription-template .patient-prescription-body .prescription-page-index .note {
                    font-size: 13px;
                }
                .patient-prescription-template .prescription-footer {
                    width: calc(100% - 40px);
                    height: 40px;
                    bottom: -30px;
                    align-items: center;
                }
                .patient-prescription-template:not(.physio-consultation-template) .prescription-card .prescription-card-header .patient-name {
                    font-size: 16px;
                }
                .patient-prescription-template:not(.physio-consultation-template) .prescription-card .prescription-card-header .patient-name .patient-details {
                    font-size: 13px;
                }
                .patient-prescription-template:not(.physio-consultation-template) .prescription-sec-heading {
                    padding-bottom: 0px;
                }
                .patient-prescription-template:not(.physio-consultation-template) ul li:first-child {
                    padding-top: 0px;
                }
                .patient-prescription-template:not(.physio-consultation-template) .signature-container {
                    position: relative;
                    top: -40px;
                }
                .patient-prescription-template:not(.physio-consultation-template) .prescription-card .prescription-card-content {
                    width: 100%;
                }

                /* PLAN PDF */
                .patient-plan-template .plan-type-header {
                    padding: 10px 0px 10px 0px;
                }
                .patient-plan-template .plan-type-header > span {
                    margin-top: 12px;
                }
                .patient-plan-template .prescription-card .prescription-card-header {
                    padding: 12px 15px 5px 0px;
                    height: 62px;
                }
                .patient-plan-template .prescription-card .prescription-card-header .prescription-card-header-item .prescription-card-header-item-label {
                    font-size: 11px;
                }
                .patient-plan-template .prescription-card .prescription-card-header .prescription-card-header-item .prescription-card-header-item-value {
                    font-size: 14px;
                }
                .patient-plan-template #vitals .vital-filler-image > img {
                    width: 180px;
                    height: 600px;
                }
                .patient-plan-template #vitals .vital-values-container .vital-row .vital-value-container .vital-header-name {
                    font-size: 12px;
                }
                .patient-plan-template #vitals .vital-values-container .vital-row .vital-value-container .patient-vital-value {
                    font-size: 16px;
                }
                /* GOALS PAGE */
                .patient-plan-template #primaryGoals .primaryGoal-item .goal-name {
                    font-size: 17px;
                }
                .patient-plan-template #primaryGoals .primaryGoal-item .goal-metrics-container .goal-metric-container .metric-name {
                    font-size: 13px !important;
                }
                .goals-metric-bar-field {
                    width: 250px !important;
                }
                .goals-metric-bar-field span {
                    font-size: 12px !important;
                }
                .goals-metric-bar-field > span {
                    left: 49% !important;
                }
                .goals-metric-bar-field {
                    font-size: 16px;
                }
                .patient-plan-template #primaryGoals .primaryGoal-item .goal-metrics-container .goal-metric-container .metric-values .goal-values-container .goal-value-container .goal-value-header {
                    font-size: 14px;
                }
                .patient-plan-template #primaryGoals .primaryGoal-item .goal-metrics-container .goal-metric-container .metric-values .goal-values-container {
                    padding-left: 35px;
                }
                .patient-plan-template #primaryGoals .primaryGoal-item .goal-metrics-container .goal-metric-container .metric-values .goal-values-container .goal-value-container .goal-value-header {
                    font-size: 14px;
                    margin: 3px 0;
                }
                #primaryGoals .primaryGoal-item .goal-metrics-container .goal-metric-container .metric-values .goal-values-container .goal-value-container .goal-value.goal-value-string {
                    font-size: 12px !important;
                }
                .patient-plan-template #secondaryGoals .secondaryGoals-header {
                    font-size: 17px;
                }
                #currentPoint-noRange, #currentPoint-range {
                    left: 190px !important;
                }
                #currentPoint-mid {
                    left: 125.5px !important;
                }
                /* CLINICAL PLAN PAGE */
                .patient-plan-metric-nametemplate #followUps h4 {
                    font-size: 17px;
                }
                .patient-plan-template #followUps .followUp-item {
                    font-size: 14.5px;
                    padding-top: 7px;
                    padding-bottom: 7px;
                }
                .patient-plan-template #chiefComplaints .chiefComplaints-header, .patient-plan-template #diagnosis .diagnosis-header {
                    font-size: 14px;
                }
                .patient-plan-template #chiefComplaints .symptom-name, .patient-plan-template #diagnosis .diagnosis-name {
                    font-size: 14.5px;
                }
                .patient-plan-template #medicinePrescription .medicine-item .medicine-name .medicine-generic-name {
                    font-size: 12px;
                }
                .patient-plan-template #medicinePrescription .medicine-item .dosage-duration-comments-container .medicine-instructions {
                    font-size: 13px;
                }
                .patient-plan-template .medicine-item .dosage-duration-comments-container .medicine-dosage .dosage-row::before {
                    width: 200px !important;
                    margin-left: 40px !important;
                }
                .patient-plan-template #referrals .referral-item {
                    font-size: 14.5px;
                }
                .patient-plan-template .prescription-sec-heading, .patient-plan-template .prescription-subheading {
                    font-size: 16px;
                }
                /* MIND PLAN PAGE */
                .patient-plan-template #diagnosisByTherapist .diagnosis-header {
                    font-size: 17px;
                }
                .patient-plan-template #diagnosisByTherapist .diagnosis-name {
                    font-size: 14.5px;
                }
                .patient-plan-template #diagnosticAssessmentByTherapist .diagnosticAssessmentByTherapist-header {
                    font-size: 18px;
                }
                .patient-plan-template #referralsByTherapist .referral-item {
                    font-size: 14.5px;
                }
                .patient-plan-template #referralsByTherapist h4 {
                    font-size: 17px;
                }
                .patient-plan-template #patientNoteSet .patientNote-item, .patient-plan-template #chiefComplaintsByTherapist .symptom-name {
                    font-size: 14.5px;
                }
                .patient-plan-template #medicinePrescription .medicine-item .medicine-name .medicine-date, .patient-plan-template #medicinePlanPrescriptionByTherapist .medicine-item .medicine-name .medicine-date {
                    font-size: 10.5px !important;
                }
                .patient-plan-template #chiefComplaintsByTherapist .symptom-name, .patient-plan-template #followUpsByLC .followUp-item {
                    font-size: 14.5px;
                }
                .patient-plan-template #medicinePrescriptionByTherapist .medicine-item .medicine-name .medicine-generic-name {
                    font-size: 12px;
                }
                .patient-plan-template #followUpsByTherapist .followUp-item {
                    font-size: 14.5px;
                }
                /* LIFESTYLE PLAN PAGE */
                .patient-plan-template #dietDoGuidelines img {
                    height: 90px;
                }
                .patient-plan-template #dietDoGuidelines #dietDoGuidelines-subsection, .patient-plan-template #dietDontGuidelines #dietDontGuidelines-subsection {
                    font-size: 15px;
                }
                #dietDoGuidelines-subsection {
                    font-size: 14px;
                }
                .patient-plan-template #overallThemes .overall-themes-header {
                    font-size: 18px;
                }
                .patient-plan-template #overallThemes .theme-text {
                    font-size: 14px;
                }
                .patient-plan-template .calories-per-day-container {
                    font-size: 20px;
                }
                /* DIET PLAN PAGE */
                .patient-plan-template .meal-slot-container .meal-slot-header img {
                    height: 45px;
                    vertical-align: middle;
                }
                .patient-plan-template .meal-slot-container .meal-slot-header {
                    font-size: 17px;
                }
                .patient-plan-template .meal-slot {
                    font-size: 16px;
                }
                .patient-plan-template .meal-slot-container .theme-row-container .theme-label {
                    font-size: 14px;
                }
                .patient-plan-template .meal-slot-container .theme-row-container .theme-value-container {
                    font-size: 14px;
                }
                .patient-plan-template .meal-options-container .meal-option-item-container .meal-number {
                    width: 20px;
                    height: 20px;
                    line-height: 22px;
                    font-size: 12px;
                }
                /* LIFESTYLE PLAN PAGE */
                .patient-plan-template #fitnessPrescription .prescription-sec-heading, .patient-plan-template #mindfulnessPrescription .prescription-sec-heading {
                    font-size: 17px;
                }
                .patient-plan-template #fitnessPrescription .prescription-card-content #fitnessPrescription-subsection li.guidelines-section > div, .patient-plan-template #fitnessPrescription .prescription-card-content #fitnessPrescription-subsection li .prescription-subheading, .patient-plan-template #fitnessPrescription .prescription-card-content #fitnessPrescription-subsection li .prescription-description, .patient-plan-template #mindfulnessPrescription .prescription-card-content #mindfulnessPrescription-subsection li.guidelines-section > div, .patient-plan-template #mindfulnessPrescription .prescription-card-content #mindfulnessPrescription-subsection li .prescription-subheading, .patient-plan-template #mindfulnessPrescription .prescription-card-content #mindfulnessPrescription-subsection li .prescription-description {
                    font-size: 13px;
                }
                .patient-plan-template #habitsPrescription .prescription-card-content .habit-item {
                    font-size: 14px;
                }
                .patient-plan-template #habitsPrescription h4, .patient-plan-template #referralsByLC h4, .patient-plan-template #followUpsByLC h4 {
                    font-size: 17px;
                }
                .patient-plan-template #habitsPrescription .prescription-card-content .habit-item .habits-filler .filler-text.row-1 {
                    font-size: 34px;
                }
                .patient-plan-template #habitsPrescription .prescription-card-content .habit-item .habits-filler .filler-text.row-2 {
                    font-size: 28px;
                }
                .patient-plan-template #referralsByLC .referral-item, .patient-plan-template #followUpsByLC .followUp-item {
                    font-size: 14.5px;
                }
                .patient-plan-template .prescription-heading {
                    font-size: 18px;
                }
                .patient-plan-template .prescription-description {
                    font-size: 16px;
                }
                .patient-plan-template .signature-container .signature-text {
                    font-size: 12px;
                }
                /* PRINT PDF */
                body.print-pdf .prescription-header {
                    display: none !important;
                }
                body.print-pdf .prescription-footer {
                    bottom: -25px;
                }
                body.print-pdf .patient-plan-template-wrapper {
                    padding-top: 12px;
                }
                body.print-pdf .doctor-container {
                    padding: 90px 25px 0px;
                }
                body.print-pdf .patient-plan-template .plan-type-header {
                    padding: 0px 0px 10px 0px;
                }
                body.print-pdf .patient-prescription-template .prescription-card {
                    margin-top: 10mm;
                }
                body.print-pdf .patient-plan-template .signature-container {
                    bottom: 70px;
                }
                body.print-pdf .patient-plan-template .prescription-footer {
                    height: 75px;
                }
                .test-details-container {
                    display: flex;
                    margin: 10px 0px;
                }
                .test-left {
                    flex: 1;
                    margin-right: 10px;
                }
                .test-right {
                    flex: 1;
                }

            </style>
        </head>
        <body class="pdf-body-container">
            <div class="prescription-template-container">
                $injectBody
            </div>
        </body>
            </html>
`;

export default template;
